import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProductionPlanningContainerView } from "src/components/views/erp/production/productionPlanning/ProductionPlanningContainerView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/production/productionPlanning")({
	staticData: { title: i18n.t("production_planning"), legacyViewKey: "productionPlanningPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProductionPlanningContainerView />;
}
